import * as React from "react";
import IRiskNotice from "./IRiskNotice";
import { classNames } from "@features/utils/reactFunctions";

import * as style from "./RiskNoticeStyle.module.scss";
import * as general from "@appStyles/general.module.scss";

const RiskNotice: React.FunctionComponent<IRiskNotice> = (props) => {
  const { isColumn } = props;

  return (
    <div
      className={classNames(
        general.appContainer,
        style.infoContainer,
        props.isColumn && style.columnNotice
      )}
    >
      <React.Fragment>
        Investing in early-stage companies involves risk. Please read our{" "}
        <a
          href={`${process.env.WORDPRESS_DOMAIN}/risk-warnings`}
          target="_blank"
          className={style.infoLink}
          rel={"noopener noreferrer"}
        >
          Risk Disclosure Statement.
        </a>
        {!isColumn && <br />}
        &nbsp;Where necessary, you should consult your legal, tax or other
        professional advisor.
      </React.Fragment>
    </div>
  );
};

export default RiskNotice;
